import React from 'react';
import TasksContainer from 'routes/Tasks/TasksContainer';

export default function TasksApprovalsContainer() {
  return <TasksContainer isApprovals />;
}
